import { ModelAdapter } from '../../../models/model-adapter.interface';
import { Injectable } from '@angular/core';

import { SupportOptionType } from '../enums/support-options-type.enum';
import { SupportOption } from '../models/try-something-else-model';

@Injectable({
  providedIn: 'root',
})
export class SupportOptionsAdapter implements ModelAdapter<SupportOption[]> {
  liveChatUid = 'angular-chat-to-us-online-v1';
  callUid = 'angular-call-us-v1';

  adapt(supportOptions: any[]): SupportOption[] {
    return supportOptions.map((supportOption) => this.createSupportOption(supportOption));
  }

  private createSupportOption(supportOptionItem: any) {
    let supportOptionType;
    let displayOrder;
    let subHeading = supportOptionItem?.supportOptions[0].copy;

    if (supportOptionItem.uid === this.liveChatUid) {
      supportOptionType = SupportOptionType.LiveChat;
      displayOrder = 1;
    } else if (supportOptionItem.uid == this.callUid) {
      supportOptionType = SupportOptionType.Modal;
      displayOrder = 2;
    } else {
      supportOptionType = SupportOptionType.Modal;
      subHeading = supportOptionItem?.subheading;
      displayOrder = 3;
    }

    return {
      uid: supportOptionItem.uid,
      type: supportOptionType,
      heading: supportOptionItem?.Heading,
      subHeading, //: supportOptionItem?.subheading,
      modal: supportOptionItem?.modal,
      imgUrl: supportOptionItem?.media[0]?.media[0]?.url,
      alt: supportOptionItem?.media[0]?.media[0]?.alternativeText || supportOptionItem?.Heading,
      href: supportOptionItem?.hyperlink[0]?.url,
      displayOrder, //: supportOptionType === SupportOptionType.LiveChat ? 1 : 2,
      targetNewPage: supportOptionItem?.hyperlink[0]?.targetNewPage,
    };
  }
}
